import { WorkModel } from "@/api/WorkModel";
import { formatMinutes } from "./DateTimeUtil";


export const NamingUtil = {

    entries(n: number): string {
        switch (n) {
            case 0: return 'Leer';
            case 1: return '1 Eintrag';
            default: return `${n} Einträge`;
        }
    },

    contract(model: WorkModel): string {
        return `${model.workPercentage}% an ${model.selectedDays.filter(d => d.selected).length} Tagen pro Woche`;
    },
    contractShort(model: WorkModel): string {
        return `${model.workPercentage}%`;
    },

    minutesPerWeek(model: WorkModel): string {
        const minutes = model.selectedDays
            .filter(d => d.selected)
            .map(d => d.percentage * model.minutesPerDay / 100)
            .reduce((a, b) => a + b, 0);
        return formatMinutes(minutes);
    }
}